import Cursor from "../vendor/cursor";
const cursor = new Cursor();
let slider_logos = $('.slider-move-logotypes');

slider_logos.liMarquee({
    scrollStop: false,
    circular: true,
    startShow: true,
    hoverStop: false,
});
